import { NamePath } from '@xbcb/ui-types';
export const tariffKey = (i: number, fullNamePath: NamePath): NamePath => {
  return [...fullNamePath, 'tariffs', i];
};

export const htsKey = (i: number, fullNamePath: NamePath): NamePath => {
  return [...tariffKey(i, fullNamePath), 'htsNumber'];
};
